import Cookies from "js-cookie";
import { getCsrfToken } from "@/app/_utils/csrf";

class LinkService {
  static instance: LinkService;

  csrfToken = getCsrfToken();
  tenant = Cookies.get("tenant") ?? "";
  baseUrl = `${import.meta.env.VITE_API_BASE_URL}`;

  getLinkAsync = async (id: string) => {
    const res = await fetch(`${this.baseUrl}links/${id}/`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };

  getLinkPreviewAsync = async (id: string) => {
    const res = await fetch(`${this.baseUrl}links/${id}/preview/`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };

  getLinksAsync = async () => {
    const res = await fetch(`${this.baseUrl}links/`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };

  getMediumsAsync = async () => {
    const res = await fetch(`${this.baseUrl}links/mediums/`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };

  getSourcesAsync = async () => {
    const res = await fetch(`${this.baseUrl}links/sources/`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };

  registerSignupAsync = async (Link: any) => {
    return await fetch(`${this.baseUrl}links/signup/`, {
      method: "POST",
      body: JSON.stringify(Link),
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": this.csrfToken,
      },
      credentials: "include",
    });
  };
  createLinkAsync = async (Link: any) => {
    const res = await fetch(`${this.baseUrl}links/`, {
      method: "POST",
      body: JSON.stringify(Link),
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": this.csrfToken,
      },
      credentials: "include",
    });

    return await res.json();
  };

  updateLinkAsync = async (id: string, Link: any) => {
    const res = await fetch(`${this.baseUrl}links/${id}/`, {
      method: "PUT",
      body: JSON.stringify(Link),
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": this.csrfToken,
      },
      credentials: "include",
    });

    return await res.json();
  };

  deleteLinkAsync = async (id: string) => {
    return await fetch(`${this.baseUrl}links/${id}/`, {
      method: "DELETE",
      headers: {
        "X-CSRFToken": this.csrfToken,
      },
      credentials: "include",
    });
  };
}

export default new LinkService();
